import React from "react";

import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import TGrid from "../../partials/content/Grid";
import { createJobStatus } from "../../crud/auth.crud";

import 'date-fns';

import { SketchPicker } from 'react-color'



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class CreateJobStatus extends React.Component {
  state = {
    
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
  }



  


constructor(props)
{
  super(props);
    this.state = {
      menu: false,
     
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
      
    };


    
  
}
  
  
  handleChangeComplete = (color) => {
    this.setState({ background: color.hex });
  };

  componentDidMount()
  {
    
    
     
  }

  



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

           <Formik
                  initialValues={{
                    jobStatusName:"",
                    jobStatusColor:"",
                    statusDescription:"",
                    
                    
                  }}
                  validate={values => {
                    const errors = {};

                    

                    
                    if (!values.jobStatusName) {
                      errors.jobStatusName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.jobStatusColor) {
                      errors.jobStatusColor = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.statusDescription) {
                      errors.statusDescription = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    

                    
                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                   
                    createJobStatus(
                      this.state.background,
                      values.jobStatusName,
                      values.statusDescription,
                      
                      
                    )
                      .then(resp => {
                        //props.register(accessToken);
                        this.setState({status:true,
                        statusMessage:'Digital Planning Status created successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
        	
      		<TGrid beforeCodeTitle="Digital Planning Status" jsCode="false">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Status Name"
                          className="kt-width-full"
                          name="jobStatusName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.jobStatusName}
                          helperText={touched.jobStatusName && errors.jobStatusName}
                          error={Boolean(touched.jobStatusName && errors.jobStatusName)}
                        />
                      </div>        

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="statusDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.statusDescription}
                          helperText={touched.statusDescription && errors.statusDescription}
                          error={Boolean(touched.statusDescription && errors.statusDescription)}
                        />
                      </div>      

                     

                      

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          className="kt-width-full"
                          name="jobStatusColor"
                          onChange={handleChange}
                          value={this.state.background}
                          helperText={touched.jobStatusColor && errors.jobStatusColor}
                          error={Boolean(touched.jobStatusColor && errors.jobStatusColor)}

                        />
                      </div>
                       <div className="col-12">

                        <SketchPicker
                            color={ this.state.background }
                            onChangeComplete={ this.handleChangeComplete }
                          />
                      </div>
                      
		   			  </div>
             
             
				   
			    </div>
		    </div>
		    </TGrid>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Create Status
                        </button>
                      </div>
       </form>
            )}
            </Formik>

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(CreateJobStatus));

